import { Checkbox, FormControlLabel } from "@mui/material";

interface CheckboxFieldDEProps {
  value: boolean | null;
  label?: string;
  disabled?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
  readonly?: boolean;
}

export const CheckboxFieldDE = ({
  value,
  label,
  disabled = false,
  onChange = () => {},
  readonly = false,
}: CheckboxFieldDEProps) => {
  return (
    <FormControlLabel
      style={{ margin: 0 }}
      control={
        <Checkbox
          disabled={disabled}
          checked={value ?? false}
          onChange={onChange}
          name={label}
          color="primary"
          inputProps={{ readOnly: readonly }}
        />
      }
      label={<span style={{ fontSize: "0.8rem" }}>{label}</span>}
    />
  );
};
